  function calculateFinanceExample(){
            $(".financeExample").each(function(){          
              let amount = $(this).data("amount");
              let term = $(this).data("term");
              let depositpercent = $(this).data("deposit-percent");
              let provider = $(this).data("provider");
              let interest = $(this).data("interest");
              let deposit = (amount / 100) * depositpercent;

              // calculate the loan info
              var loan_info = $.loanInfo({
                    amount:"£"+(Number(amount)-Number(deposit)).toFixed(2),
                    rate:Number(interest).toFixed(2)+"%",
                    term:+term.toString()+"m",
              });          
             $(this).html(
                  '<p>Spread the cost. Pay <strong>£'+Number(loan_info.payment_amount).toFixed(2)+'</strong>/month with <span class="logo">'+provider+'</span></p>'+
                  '<p><strong>Representative Example:</strong> £'+Number(deposit).toFixed(2)+' upfront payment. Total loan amount £'+(amount-deposit).toFixed(2)+'. Interest rate of '+Number(interest).toFixed(2)+'%. '+loan_info.num_payments.toString()+' monthly payments of £'+Number(loan_info.payment_amount).toFixed(2)+'. Estimated total amount payable £'+Number(loan_info.total_payments).toFixed(2)+'.</p>'
              );          
            });
          }
          $(document).ready(function(){
            calculateFinanceExample();
          });